export const LOADING_BAR_SHOW = "LOADING_BAR_SHOW";
export const LOADING_BAR_FINISHED = "LOADING_BAR_FINISHED";
